module.exports = __webpack_public_path__ + "static/media/dominio_negocio.31316e95.png";